import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
})
export class ErrorComponent {

    constructor(
        private activatedRoute: ActivatedRoute,
        private location: Location,
        ) { }

    public reloadPage(): void {

        this.activatedRoute.queryParamMap.subscribe((params) => {
            const url = window.decodeURI(params.get('returnUrl'));
            const urlNormalize = this.location.normalize(url);
            this.location.go(urlNormalize);
            window.location.reload();
        });

    }
}
